import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d930a20c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jumbotron bg-dark" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "display-5" }, "Site under construction", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Thanks for your interest in Maya Pinball. Product information will be available here shortly. In the interim, follow social accounts for updates. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "my-4" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "lead text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://instagram.com/mayapinball",
    target: "_blank",
    class: "btn btn-secondary btn-lg mr-4",
    role: "button"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fab fa-instagram" })
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    href: "http://facebook.com/mayapinball",
    target: "_blank",
    class: "btn btn-secondary btn-lg",
    role: "button"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fab fa-facebook" })
  ])
], -1))
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_6))
}